var map = {
	"./bank-transfer.svg": 1119,
	"./betnearn-ico.svg": 1120,
	"./birthday-bonus-ico.svg": 1121,
	"./birthday.svg": 1122,
	"./bonus-code-ico.svg": 1123,
	"./bonus-ico.svg": 1124,
	"./bonus-received-ico.svg": 1125,
	"./bonus.svg": 1126,
	"./business-account-upgrade-ico.svg": 1127,
	"./check-in-daily-ico.svg": 1128,
	"./checked.svg": 1129,
	"./cloud-pointer.svg": 1130,
	"./coin.svg": 1131,
	"./crypto.svg": 1132,
	"./daily-bonus-ico.svg": 1133,
	"./daily-limit.svg": 1134,
	"./deposit-delay-bonus-ico.svg": 1135,
	"./e-wallet.svg": 1136,
	"./earn-x33-coin-ico.svg": 1137,
	"./email.svg": 1138,
	"./facebook.svg": 1139,
	"./feedback.svg": 1140,
	"./first-bet-ico.svg": 1141,
	"./games-rebate-ico.svg": 1142,
	"./info.svg": 1143,
	"./instagram.svg": 1144,
	"./live-casino-rebate-ico.svg": 1145,
	"./lucky-spin-ico.svg": 1146,
	"./messenger.svg": 1147,
	"./mobile-app-deposit-ico.svg": 1148,
	"./monthly-cash.svg": 1149,
	"./msg-activity.svg": 1150,
	"./msg-ann.svg": 1151,
	"./msg-notice.svg": 1152,
	"./new-icon.svg": 1153,
	"./people-ico.svg": 1154,
	"./quick-pay.svg": 1155,
	"./rescue-bonus-ico.svg": 1156,
	"./rescue-lc-ico.svg": 1157,
	"./rescue-slots-ico.svg": 1158,
	"./return.svg": 1159,
	"./sc-bc-active-ico.svg": 1160,
	"./sc-bc-ico.svg": 1161,
	"./sc-bi-active-ico.svg": 1162,
	"./sc-bi-ico.svg": 1163,
	"./sc-mail-active-ico.svg": 1164,
	"./sc-mail-ico.svg": 1165,
	"./sc-mp-active-ico.svg": 1166,
	"./sc-mp-ico.svg": 1167,
	"./sc-pin-active-ico.svg": 1168,
	"./sc-pin-ico.svg": 1169,
	"./slots-rebate-ico.svg": 1170,
	"./sports-rebate-ico.svg": 1171,
	"./telegram.svg": 1172,
	"./twitter.svg": 1173,
	"./vip-up-level-ico.svg": 1174,
	"./vip-weekly-bonus.svg": 1175,
	"./wallet-balance-interest-ico.svg": 1176,
	"./wallet-ico.svg": 1177,
	"./weekly-tournament-ico.svg": 1178,
	"./welcome-bonus-188-ico.svg": 1179,
	"./welcome-bonus-ico.svg": 1180,
	"./whatsapp.svg": 1181,
	"./withdrawal-delay-bonus-ico.svg": 1182,
	"./withdrawal.svg": 1183,
	"./x33-coin.svg": 1184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;